import { API_BASE_URL } from '../utils/api'

export type BetaInterestStatus = 'pending' | 'activated'

export interface BetaInterestItem {
  id: string
  name: string
  email: string
  whatsapp: string | null
  source: string | null
  status: BetaInterestStatus
  activatedAt: string | null
  notifiedAt: string | null
  createdAt: string
}

export interface BetaInterestList {
  items: BetaInterestItem[]
  total: number
  counts: { pending: number; activated: number }
  page: number
  limit: number
}

export interface BetaInterestFilters {
  status?: BetaInterestStatus
  search?: string
  page: number
  limit: number
}

export interface StatusChangeResult {
  id: string
  status: BetaInterestStatus
  emailSent: boolean
}

const authHeaders = (token: string | null): HeadersInit => ({
  'Content-Type': 'application/json',
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
})

async function readError(res: Response, fallback: string): Promise<Error> {
  const body = (await res.json().catch(() => ({}))) as { message?: string }
  return new Error(body.message || fallback)
}

export const betaInterestAdminService = {
  async list(filters: BetaInterestFilters, token: string | null): Promise<BetaInterestList> {
    const params = new URLSearchParams({ page: String(filters.page), limit: String(filters.limit) })
    if (filters.status) params.set('status', filters.status)
    if (filters.search?.trim()) params.set('search', filters.search.trim())

    const res = await fetch(`${API_BASE_URL}/admin/beta-interest?${params}`, { headers: authHeaders(token) })
    if (!res.ok) throw await readError(res, 'No se pudo cargar la lista de reservas')
    return res.json()
  },

  async setStatus(
    id: string,
    status: BetaInterestStatus,
    notify: boolean,
    token: string | null
  ): Promise<StatusChangeResult> {
    const res = await fetch(`${API_BASE_URL}/admin/beta-interest/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      headers: authHeaders(token),
      body: JSON.stringify({ status, notify }),
    })
    if (!res.ok) throw await readError(res, 'No se pudo actualizar la reserva')
    return res.json()
  },
}
